<template>
	<v-dialog v-model="dialog" max-width="800" persistent>
    <v-card class="elevation-0 pa-1">
      <v-card-title>
        <span class="headline">Invoice client</span>
        <v-spacer></v-spacer>
          <v-btn-toggle
          v-if="mode === 'invoice'"
          v-model="invoiceType"
          mandatory
          dense
          @click.native="toggleInvoiceType"
          color="primary"
          group

        >
            <v-btn icon>
              <v-icon>filter_none</v-icon>
            </v-btn>
            <v-btn icon>
              <v-icon>filter_1</v-icon>
            </v-btn>
            <v-btn icon>
              <v-icon>filter_2</v-icon>
            </v-btn>
            <v-btn icon>
              <v-icon>filter_3</v-icon>
            </v-btn>
          </v-btn-toggle>


          <v-btn v-if="!invoiceId" fab small color="primary mx-1" dark @click.native="makeInvoice">
            <v-icon>receipt</v-icon>
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn icon @click.native="print">
            <v-icon>print</v-icon>
          </v-btn>
          <v-btn icon @click.native="close">
            <v-icon>close</v-icon>
          </v-btn>

      </v-card-title>
      <v-divider></v-divider>
      <v-spacer></v-spacer>
      <v-layout wrap grid-list-md id="invoice" ref="invoice" class="invoiceToPrint">
        <v-card class="invoice elevation-0" style="width:100%">
        <div class="firstPage">
          <v-container>
            <div class="invoice-header">

              <m-company-address :settings="settings"></m-company-address>

                <v-spacer></v-spacer>


                <m-invoice-address class="client-invoice-adress" :selectedItem="selectedItem"></m-invoice-address>


            </div>

            <v-card-title class="px-7 py-1">
              <div v-if="invoiceId" class="grey--text">
                <div >Date: <span class="primary--text pr-2">{{ selectedItem.date | date }}</span> Facture N°: <span class="primary--text">{{ invoiceId | zeroFill }}</span></div>
              </div>
              <v-spacer></v-spacer>
              <span class="title" v-if="invoiceType">{{ invoiceType }}<sup>e</sup> Rappel de paiement</span>
            </v-card-title >


            <v-card-title >
              <div class="pre-total">
              <table>
                <tbody>
                  <tr class="">
                    <td colspan="8">Total du transport</td><td class="text-right">{{ price.total | currency }}</td>
                  </tr>
                  <tr v-if="price.admin">
                    <td colspan="8">Frais administratifs </td><td class="text-right">{{ price.admin | currency}}</td>
                  </tr>
                  <tr class="title line">
                    <td colspan="8" class="title"><strong>Total</strong></td><td class="title text-right"><strong>{{ (price.total + price.admin) | currency}}</strong></td>
                  </tr>
                </tbody>
              </table>
              </div>

            <div class="invoice-copy tva-copy mt-4 pa-2">

              <div v-if="invoiceType === 1">
                <div>Madame, Monsieur,</div>
                <br>
                Sauf erreur de notre part, notre facture N° {{ invoiceId | zeroFill }} en date du {{ selectedItem.date | date }} d'un montant de <strong>{{ (price.total + price.admin) | currency}}</strong>, n'a toujours pas été réglée à ce jour.
                Nous pensons qu'il s'agit d'un oubli, et nous vous remercions de bien vouloir nous adresser dans les plus brefs délais votre règlement.<br>
                <br>
                Vous remerciant de faire le nécessaire, et restant à votre entière disposition pour toute question,
                <br> nous vous prions d’agréer, Madame, Monsieur, l’expression de nos salutations distinguées.
              </div>

              <div v-else-if="invoiceType === 2">
                <div>Madame, Monsieur,</div><br>
                Vous n’avez pas réagi à nos précédentes rappel de paiement.
                <br>
                Pour autant que nécessaire, nous vous mettons en demeure de verser <strong>{{ (price.total + price.admin) | currency}}</strong> dans les 7 jours
                <br>(avant le {{ currentDate }}) sur notre compte bancaire ING <span class="heavy">BE71363172410769</span>.
                <br>Merci de mentionner la communication <strong>{{ invoiceId | zeroFill }}/{{ selectedItem.clientId }}</strong>.
                <br><br>
                Faute de réaction de votre part, nous nous verrons dans l’obligation de transmettre le dossier à un service d’huissier de justice, comme le prévoit nos conditions générales, vous serez dès-ce jour redevable de frais supplémentaire.
                <br><br>
                Si vous le souhaitez, n’hésitez pas à me contacter: +32485157611 ou service@help4you.be.
              </div>

              <!-- <div v-else>
                <div v-if="factuurType">
                  <span>Merci d'effectuer votre versement des les 15 jours sur notre compte ING <span class="heavy">BE71363172410769</span></span><br>
                  <span v-if="invoiceId">Avec la communication: <span class="heavy primary--text">{{ invoiceId | zeroFill }}/{{ selectedItem.clientId }}</span>
                  </span>
                </div>
                <div v-else>
                Facture acquittée (ou paiement en espèces, example: ticket modérateur maximum par jour)
                </div>
              </div> -->

              <div v-else>
                <div v-if="price.admin">
                  <span>Merci d'effectuer votre versement des les 15 jours sur notre compte ING <span class="heavy">BE71363172410769</span></span><br>
                  <span v-if="invoiceId">Avec la communication: <span class="heavy primary--text">{{ invoiceId | zeroFill }}/{{ selectedItem.clientId }}</span>
                  </span>
                </div>
              </div>
            </div>

            </v-card-title>
          </v-container>
          <m-sepa v-if="price.admin" class="sepa" :company="settings" :amount="(price.total + price.admin)" :client="selectedItem" :invoiceId="invoiceId || 0"></m-sepa>
        </div>
        <v-container>
          <div class="v-data-table v-data-table--dense theme--light">
            <div class="v-data-table__wrapper">
            <table >
              <thead>
                <tr>
                <th class="text-left">N°</th>
                <th class="text-left">Date</th>
                <th class="text-left">Destination</th>
                <th class="text-left">Type</th>
                <th class="text-left">Tarif</th>
                <th class="text-left">Temps acc.</th>
                <th class="text-left">Tarif acc.</th>
                <th class="text-left">Parking</th>
                <th class="text-right">Total du transport</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in bookings" :key="i">
                  <td >{{ item.id }}</td>
                  <td >{{ item.ap_date }} {{ item.ap_time | formatTime }}</td>
                  <td >{{ item.destination_name }}</td>
                  <td >{{ item.type | formatIndex(types)}}</td>
                  <td >{{ item.price | currency }} <span v-if="item.noMutIntervention && item.mutualPatientAmount" >- {{ item.mutualPatientAmount | currency}}</span></td>
                  <!-- <td >{{ item.dist }} km</td> -->
                  <td >{{ item.ap_waittime}} </td>
                  <td >{{ item.waitprice | currency}}</td>
                  <td >{{ item.ticket_price | currency }}</td>
                  <td class="text-right">{{ (item.waitprice + item.price + item.ticket_price) - (item.noMutIntervention && item.mutualPatientAmount || 0)| currency }}</td>
                </tr>
                <tr class="">
                  <td colspan="8">Sous total</td><td class="text-right">{{ price.total | currency }}</td>
                </tr>
                <tr>
                  <td colspan="8">Frais administratifs </td><td class="text-right">{{ price.admin | currency}}</td>
                </tr>
                <tr class="title big-line">
                  <td colspan="8" class="title"><strong>Total</strong></td><td class="title text-right"><strong>{{ (price.total + price.admin) | currency}}</strong></td>
                </tr>
              </tbody>
            </table>
            </div>
            </div>


            <m-invoice-footer :settings="settings"></m-invoice-footer>


        </v-container>
        </v-card>
      </v-layout>
    </v-card>
	</v-dialog>
</template>
<script>

import moment from 'moment';
import MCompanyAddress from '@/components/invoices/company'
import MInvoiceAddress from '@/components/invoices/address'
import PrintMixin from '@/mixins/print'
import WalletMixin from '@/mixins/wallet'
import MSepa from '@/components/invoices/sepa'
export default {
  name: 'invoice',
  props: ['dialog', 'selectedItem', 'filteredBookings', 'start', 'end', 'factuurType', 'mode'],
  mixins: [PrintMixin, WalletMixin],
  components: {
    'm-company-address': MCompanyAddress,
    'm-invoice-address': MInvoiceAddress,
    'm-sepa': MSepa
  },
  data () {
    return {
      menu_date_start: false,
      menu_date_end: false,
      dateFormatted_start: null,
      dateFormatted_end: null,
      currentMonth: moment().format('MMMM YYYY'),
      currentDate: moment().add(7,'day').format('DD/MM/YYYY'),
      search: '',
      search_clients: '',
      pagination: {
        sortBy: 'ap_date',
        descending: true
      },
      form: {},
      modes: ['pending', 'closed', 'unfounded', 'canceled'],
      types: {
        to: 'Aller',
        back: 'Retour',
        simple: 'Simple'
      },
      items: [],
      invoiceType: 0,
      invoiceId: null,
      invoiceDate: null,
      headers: [
        {
          text: 'N° de réservation',
          width: '10',
          value: 'id'
        },
        { text: '​Date', value: 'ap_date' },
        { text: '​Destination', value: 'destination_name' },
        { text: 'Type trajet', value: 'type' },
        { width: 70, text: 'Tarif', value: 'price' },
        { text: 'Distance', value: 'dist' },
        { text: 'Accompagnement', value: 'ap_waittime' },
        { text: 'Tarif 2', value: 'waitprice' },
        { text: 'Total du transport' }

      ],
      bookings: [],
      invoiceDone: false,
      price_admin: 3,
      price: {
        admin: 3,
        total: 0
      }
    }
  },
  methods: {
    tableFilter (items, search, filter) {
      search = search.toString().toLowerCase()
      return items.filter(row => filter(row['facture'], search));
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    onRefresh () {
      this.getData();
    },
    close () {
      this.$emit('close');
    },
    print () {
      //var date = moment(this.selectedItem.date).format('MM-YYYY')
      var filename = this.invoiceId ? (
        this.invoiceId + '-' + this.selectedItem.clientId + '-' + this.selectedItem.lastname
        + (this.invoiceType ? ('-' + this.invoiceType) : '')
      ) : 'invoice';

      this.printInvoice(filename);
    },
    getData (status) {
      this.$http
      .post('service/wallet/totalByClient', {status: status || 1})
      .then(response => {
        console.log('wallet response 2', response.data);

        this.items = response.data;
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    },
    toggleInvoiceType () {
      console.log('toggleInvoiceType: ', this.invoiceType);
      if (this.invoiceId) {
        this.updateInvoice({id: this.invoiceId, data : {recall:this.invoiceType}});
      }
    },
    getInvoiceId () {
      return new Promise((resolve, reject) => {
        this.$http
        .post('service/wallet/getClientInvoiceId', {status: status || 1})
        .then(response => {
          console.log('getInvoiceId response 2', response.data);
          if (response.data[0].id) {
            this.invoiceId = response.data[0].id;
            resolve(this.invoiceId);
          }
        })
        .catch(function (error) {
          reject(error);
        });
      });
    },
    setInvoice (data) {
      return new Promise((resolve, reject) => {
        this.$http
        .post('service/wallet/setInvoice', data)
        .then(() => {
          resolve(this.invoiceId);
        })
        .catch(function (error) {
          reject(error);
        });
      });
    },
    updateInvoice (data) {
      this.$emit('update', data);
    },
    makeInvoice () {
      var app = this;
      app.invoiceDone = true;
      this.getInvoiceId().then((id) => {
        app.invoiceDate = moment().format('YYYY-MM-DD');
        var data = {
          invoice: {
            id: id,
            clientId: app.selectedItem.clientId,
            date: app.invoiceDate,
            amount: (app.price.total + app.price.admin),
            factuur: this.factuurType || 0
          },
          bookings: app.bookings.map((booking) => { return booking.id })
        }
        this.setInvoice(data).then(() => {
          console.log('setInvoice all done');
        });
      });
    },
    getBookings () {
      var app = this;
      app.invoiceDone = false;
      app.invoiceType = this.selectedItem.recall || 0;
      app.invoiceId = this.selectedItem.id || null;
      app.bookings = this.filteredBookings;
      this.calcInvoice()
    },
    init (v) {
      if (v) {
        this.getBookings();
        this.getSettings();
      }
    }
  },
  filters: {
    date: function (date) {
      return moment(date).format('DD/MM/YYYY');
    },
    formatIndex (v, obj) {
      return obj[v];
    },
    toTime (sec) {
      var time;
      if (sec > 3600) {
        time = new Date(sec * 1000).toISOString().substr(11, 5) + ' h'
      } else {
        time = new Date(sec * 1000).toISOString().substr(14, 2) + ' mins'
      }
      return time;
    },
    zeroFill (value) {
      var length = 6;
      var number = value;
      if (number) {
        return new Array(length - number.toString().length + 1).join('0') + number;
      }
    }
  },
  watch: {
    dialog (value) {
      this.init(value);
    }
  },
  created () {}
}
</script>
<style lang="scss">
  .no-break {
    white-space: nowrap;
  }
  .tm-toolbar {
    &.v-toolbar {
      background-color: transparent !important;
    }
  }
tr.status {
  &-1 {
    background:rgba(32, 151, 2, 0.1) !important;
  }
  &-2 {
    background:rgba(248, 1, 1, 0.1) !important;
  }
}

.invoice-header {
  position:relative;
  padding: 2px 16px;
  font-size: 14px;
  line-height: 1.5;
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  .client-invoice-adress {
    padding: 10px 25px;
    position: absolute;
    top: 132px;
    left: 337px;
    width: 380px;
    height: 140px;
    &.address-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      border: 1px solid rgba(0,0,0,.3);

      &::before, &::after {
        content: '';
        display: block;
        position: absolute;
        background: #fff;
      }

      &::before {
        top: -0.3em; // let it overlap a bit to prevent thin line which could appear during scaling in some browsers etc.
        bottom: -0.3em;
        left: 1em;
        right: 1em;
      }

      &::after{
        left: -0.3em;
        right: -0.3em;
        top: 1em;
        bottom: 1em;
      }

      // you need this to move the text in front of the ::after overlay
      .heading {
        position: relative;
        z-index: 1;
      }
    }
  }
}

.invoice{
  .v-data-table table {
    border-collapse: collapse;
    tbody td:first-child, tbody td:not(:first-child),
    tbody th:first-child, tbody th:not(:first-child),
    thead td:first-child, thead td:not(:first-child),
    thead th:first-child, thead th:not(:first-child) {
        padding: 0 2px;
    }
    tbody td,
    tbody th {
        height: 40px;
    }
  }

  .v-card__title {
    padding: 16px;
    font-size: 14px;
    line-height: 1.5;
  }
  .big-line{
    border-top: 2px solid rgba(0,0,0,.5) !important;
  }
}

.pre-total {
  table {
    border-collapse: collapse;
    width: 100%;
    .line{
      border-top: 1px solid rgba(0,0,0,.5) !important;
    }
  }

  width: 100%;
  border: solid 1px #000;
  padding: 10px;

}
.invoice-copy {
  word-break: keep-all;
}

.tva-copy {
  width: 100%;
  .heavy{
    font-weight:600
  }
}
.tva-footer{
 width: 100%;
}

@media print {
  div {
    overflow:initial !important
  }

  .v-data-table {
    td.page-break  {
      color: red;

      width: 100%;
    }
    tbody td:first-child,
    tbody td:not(:first-child),
    tbody th:first-child,
    tbody th:not(:first-child),
    thead td:first-child,
    thead td:not(:first-child),
    thead th:first-child,
    thead th:not(:first-child) {
      padding: 0 10px
    }
  }
  .firstPage {
    position:relative;
    width: 100vw;
    height: 100vh;
    top:0px;
    bottom:0px;
    margin: auto;
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    page-break-after: always;
    .container {
      padding-top: 0px !important;
    }
    .sepa {
      width:100%;
      bottom:0;
      left:0;
      background: white;
      display: block;
      position: absolute;
    }
  }
}

</style>
